import { Helmet } from "react-helmet";
import SelectPackage from "../components/AiHomePage/SelectPackage";
import BannerSection from "../components/YouTubeThumbnailHome/BannerSection";
import FeaturesSection from "../components/YouTubeThumbnailHome/FeaturesSection";
import AboutSection from "../components/YouTubeThumbnailHome/AboutSection";
import TestimonialSection from "../components/YouTubeThumbnailHome/TestimonialSection";


const Home = () => {
  return (
    <main>
      <Helmet>
        <title>Convert Design Images to HTML & CSS Instantly</title>
        <meta
          name="description"
          content="Upload UI designs and get clean, responsive HTML & CSS in seconds. Production-ready code, accessible markup, and pixel-perfect results for developers and designers."
        />
        <meta
          name="keywords"
          content="Convert design to HTML CSS, Image to HTML converter, Design to code tool, Convert UI to HTML CSS, AI design to code generator, Sketch to HTML CSS,Responsive HTML CSS generator, Web design to code converter, UI/UX to HTML CSS tool, Export design to HTML CSS, Instant HTML CSS from images, Online design to front-end code"
        />
        <meta
          property="og:title"
          content="Convert UI/UX Images to HTML & CSS Instantly "
        />
        <meta
          property="og:description"
          content="Upload UI designs and get clean, responsive HTML & CSS in seconds. Production-ready code, accessible markup."
        />
      </Helmet>
      <BannerSection />
      <FeaturesSection />
      <AboutSection />
      <SelectPackage />
      <TestimonialSection />
    </main>
  );
};

export default Home;
